import { render, staticRenderFns } from "./TheTable.vue?vue&type=template&id=7ca09da0&scoped=true"
import script from "./TheTable.vue?vue&type=script&lang=ts"
export * from "./TheTable.vue?vue&type=script&lang=ts"
import style0 from "./TheTable.vue?vue&type=style&index=0&id=7ca09da0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca09da0",
  null
  
)

export default component.exports